/**
 * Marking a typed answer (`type_answer` slides).
 *
 * A typed answer is right when it says the same thing as one of the slide's accepted
 * answers once the differences nobody would call a mistake are removed:
 *
 * - case: "Nairobi" and "nairobi";
 * - accents: "Éléphant" and "elephant", since a phone keyboard may not offer them;
 * - spacing: leading, trailing and repeated spaces;
 * - a full stop or exclamation mark at the end, and quotes around the whole answer.
 *
 * Nothing else is forgiven. Punctuation inside an answer can be the answer ("C++" is not
 * "C#"), and spelling variants are the presenter's call: they add each one they accept.
 */

/** The answer reduced to what is compared. Pure, and the same on server and phone. */
export function normaliseTypedAnswer(text: string): string {
  return text
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/\s+/gu, " ")
    .replace(/^[\s"'“”‘’«»¿¡]+/u, "")
    .replace(/[\s"'“”‘’«».!?。！？]+$/u, "");
}

/**
 * Does `text` match any of `accepted`? An accepted answer that normalises to nothing
 * matches nothing: an empty string must never mark every answer right.
 */
export function matchesAcceptedAnswer(text: string, accepted: readonly string[]): boolean {
  const given = normaliseTypedAnswer(text);
  if (given === "") return false;
  return accepted.some((a) => normaliseTypedAnswer(a) === given);
}
